<template>
  <div class="auth-layout">
    <div class="nav hidden-lg-up"><router-link class="basix-home" :to="{path: '/'}"></router-link></div>
    <div class="main row">
      <div :class="`auth-content ${!isRegisterForm? 'col-md-6' :'col-md-10'}`">
        <router-view></router-view>
      </div>
      <div :class="`auth-wallpaper ${!isRegisterForm? 'col-md-6' :'col-md-2 reg-form'}`">
        <img class="logo-presidencia" src="../images/logoPresidencia.png" alt="Logo">
        <!--<div class="oblique"></div>-->
        <router-link class="basix-home" :to="{path: '/'}"><img src="../images/logo.png" alt="Logo"></router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AuthLayout',
  computed: {
    isRegisterForm () {
      return this.$route.path.match('pub/registroInspirador') || this.$route.path.match('shared')
    }
  }
}
</script>

<style lang="scss">
  .auth-layout {
    height: 100vH;
    margin: 0;
    overflow: hidden;
    .main {
      margin: 0;
      height: 100%;
      .auth-content {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
      }
      .auth-wallpaper {
        background-color: #e54b95;
        display: flex;
        align-items: center;
        justify-content: center;
        .basix-home {
          z-index: 2;
          font-size: 2.625rem;
          color: #1ec260;
        }
        .logo-presidencia {
          position: absolute;
          top: 15px;
          width: 280px;
          @media screen and (min-width: 768px) {
            top: 40px;
            width: 350px;
            left: 0;
            transform: translateX(-50%);
          }
        }
        .oblique {
          position: absolute;
          // background-color: rgba($color: #33cefe, $alpha: 0);
          left: calc(50% - 23%/2);
          transform: rotate(150deg);
          width: 27%;
          height: 115%;
        }
      }
    }
  }
  .reg-form {
      .logo-presidencia {
        position:inherit !important;
      }
  }
  @media (min-width: 768px) {
    .reg-form {
      & img{
        max-width: fit-content !important;
      }
      .basix-home{
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
      }
      .logo-presidencia {
        position:absolute !important;
        transform: translateX(-63%) !important;
        z-index: 2;
      }
    }
  }
</style>
